import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const minLessThanMaxValidator = (): ValidatorFn => {
    return (group: AbstractControl): ValidationErrors | null => {
        const min = group.get('minLabel')?.value;
        const max = group.get('maxLabel')?.value;

        if (isNaN(min) || isNaN(max)) {
            return null;
        }

        const isMinPresent = min !== null && min !== '';
        const isMaxPresent = max !== null && max !== '';

        if (!isMinPresent && !isMaxPresent) {
            return null;
        }

        if (isMinPresent !== isMaxPresent) {
            return { minGreaterThanMax: true };
        }

        return Number(min) > Number(max) ? { minGreaterThanMax: true } : null;
    };
};
